import Decoder from '@/vendor/broadway/decoder'
import { Bytestream, MP4Reader } from '@/vendor/broadway/mp4'

export default (
  videoPath,
  { onLoadedVideo = () => {}, onDecode = () => {}, onFinishDecode = () => {} },
) => {
  const canvasData = []
  let sampleLength = 0

  // fetch data
  // let videoData = new Uint8Array()
  fetch(videoPath)
    .then(res => res.arrayBuffer())
    .then(d => {
      onLoadedVideo()
      onComplete(d)
    })

  // decode
  let avc = new Decoder({
    rgb: true,
  })
  avc.onPictureDecoded = onPictureDecoded

  function onComplete(readablestream) {
    const reader = new MP4Reader(new Bytestream(readablestream))
    reader.read()
    const video = reader.tracks[1]
    sampleLength = video.getSampleCount()
    // const size = new Size(video.trak.tkhd.width, video.trak.tkhd.height)

    const avcC = reader.tracks[1].trak.mdia.minf.stbl.stsd.avc1.avcC

    /* Decode Sequence & Picture Parameter Sets */
    avc.decode(avcC.sps[0])
    avc.decode(avcC.pps[0])

    /* Decode Pictures */

    let pic = 0
    setTimeout(
      function foo() {
        const sampleNALUnits = video.getSampleNALUnits(pic)
        sampleNALUnits.forEach(nal => {
          avc.decode(nal)
        })
        if (sampleNALUnits.length !== 0) {
          pic++
          // setTimeout(foo.bind(this))
          foo.bind(this)()
        } else {
          onFinishDecode(canvasData, sampleLength)
        }
      }.bind(this),
    )
  }

  function onPictureDecoded(mx, width, height) {
    canvasData.push({
      mx,
      width,
      height,
    })
    onDecode(canvasData, sampleLength)
  }
}
